import { Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleTagAnalyticsService {
  constructor() {
    window.dataLayer = window.dataLayer || [];
  }

  // usar gtag si existe, sino fallback a dataLayer.push
  private push(...args: any[]) {
    if (typeof window.gtag === 'function') {
      window.gtag(...args);
    } else {
      window.dataLayer.push(args);
    }
  }

  event(name: string, paramsGlobal?: Record<string, any>) {
    // para gtag: gtag('event', name, params)
    // para dataLayer: push({ event: name, ...params })
    const auth = localStorage.getItem('auth')
      ? JSON.parse(localStorage.getItem('auth')!)
      : { user: null };

    const params = {
      ...paramsGlobal,
      user_id: auth?.user !== null ? auth.user.id : 'null',
      logged_in: auth?.user !== null ? 'true' : 'false',
      url: window.location.href,
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    } else {
      window.dataLayer.push({
        event: name,
        ...params,
      });
    }
  }

  setUserId(userId: string) {
    if (typeof window.gtag === 'function') {
      window.gtag('set', { user_id: userId });
      window.gtag('config', 'G-2LMTSTH232', { user_id: userId });
    } else {
      window.dataLayer.push({ user_id: userId });
    }
  }
}
